import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import SimpleHorizontalScroller from '../../simpleHorizontalScroller';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    main: {
      width: '100%',
    },
    count: {
      fontFamily: 'ProximaNova-Bold',
    },
    scrollArrow: {
      top: 14,
      [breakpoints.up('xLg')]: {
        top: 11,
      },
    },
    step: {
      borderRight: `1px solid ${primary.bluish7}`,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      paddingRight: spacing(17),
      paddingLeft: spacing(17),
      '&:last-of-type': {
        border: 'none',
      },
    },
    contentWrapper: {
      display: 'grid',
      textAlign: 'center',
      height: 40,
      minWidth: 60,
      width: 'fit-content',
      maxWidth: '100%',
    },
    stepTitle: {
      paddingTop: spacing(2),
      whiteSpace: 'nowrap',
    },
  })
);

const RecruitmentSteps = ({ steps = [], onJobClick }) => {
  const classes = useStyles();
  const stepItems = steps?.map((step, index) => {
    return (
      <div
        key={`step_${index}`}
        className={classes.step}
        onClick={() => onJobClick(step.id)}
      >
        <div className={classes.contentWrapper}>
          <Typography className={classes.count} variant="body2">
            {step.number_of_candidates}
          </Typography>
          <Typography className={classes.stepTitle} variant="body2">
            {step.title}
          </Typography>
        </div>
      </div>
    );
  });

  return (
    <div className={classes.main}>
      <SimpleHorizontalScroller
        items={stepItems}
        scrollArrowClass={classes.scrollArrow}
      />
    </div>
  );
};

RecruitmentSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({})),
  onJobClick: PropTypes.func.isRequired,
};

export default RecruitmentSteps;
